import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ConsentService} from '../service/consent.service';
import {MatDividerModule} from '@angular/material/divider';
import {PreferencesComponent} from './preferences.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {PreferencesRoutingModule} from './preferences-routing.module';
import {InvestormenuModule} from '../investormenu/investormenu.module';
import {LoanAgreementModule} from '../loanAgreement/loanAgreement.module';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FinzyBoltConsentsComponent} from '../finzy-bolt-consents/finzy-bolt-consents.component';
import {RatingSelectorModule} from '../portfolio-creation/rating-selector/rating-selector.module';
import {IndianCurrencyFormatterModule} from '../views/common/indian-currency-formatter/indian-currency-formatter.module';
import {KnowMoreAboutMasterPreferredRatingsComponent} from './know-more-about-master-preferred-ratings/know-more-about-master-preferred-ratings.component';
import {InvestmentPreferencesResolver} from '../resolvers/investment-preferences.resolver';
import {ShowTurnOffSwiftPopupUtil} from '../utils/finzy-flex/show-turn-off-swift-popup.utils';
import { SharedModule } from '../shared/shared.module';
import { MaxLoanAmountSelectorModule } from '../portfolio-creation/max-loan-amount-selector/max-loan-amount-selector.module';
import { LoanTenureSelectorModule } from '../portfolio-creation/loan-tenure-selector/loan-tenure-selector.module';

const materialImports = [FormsModule, MatInputModule, MatSlideToggleModule, MatButtonModule, MatProgressSpinnerModule,
    MatDialogModule, MatCardModule, MatCheckboxModule, MatDividerModule];

const customModules = [PreferencesRoutingModule, CommonSectionsModule, InvestormenuModule,
    LoanAgreementModule, RatingSelectorModule, IndianCurrencyFormatterModule, SharedModule, MaxLoanAmountSelectorModule,
    LoanTenureSelectorModule];

@NgModule({
    providers: [ConsentService, InvestmentPreferencesResolver, ShowTurnOffSwiftPopupUtil],
    exports: [PreferencesComponent],
    entryComponents: [FinzyBoltConsentsComponent, KnowMoreAboutMasterPreferredRatingsComponent],
    declarations: [PreferencesComponent, FinzyBoltConsentsComponent, KnowMoreAboutMasterPreferredRatingsComponent],
    imports: [...customModules, ...materialImports],
})
export class PreferencesModule {
}
